import theme from '@ilg-totallymoney/ui/theme'

export const borderStyle = `1px solid ${theme.grey30}`
